import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-open-other-profile-modal',
  templateUrl: './open-other-profile-modal.component.html',
  styleUrls: ['./open-other-profile-modal.component.scss']
})
export class OpenOtherProfileModalComponent {
  @Input() instanceUrl: string = '';

  copied: boolean = false;

  constructor(private modalCtrl: ModalController) {}

  copyLink() {
    navigator.clipboard.writeText(this.instanceUrl);
    this.copied = true;
    setTimeout(() => { this.copied = false; }, 2000);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
